import { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { chat as defaultChat } from '../../../theme/tokens/semantic';
import { radius as defaultRadius } from '../../../theme/tokens/radius';
import { shadows as defaultShadows } from '../../../theme/tokens/shadows';

/**
 * Reads onboarding feature tokens from palette.chat (WhatsApp-style green in feature scope).
 */
export default function useOnboardingTheme() {
  const theme = useTheme();

  return useMemo(() => {
    const chat = theme.palette?.chat ?? defaultChat;
    const accent = {
      primary: chat.primary,
      primaryDark: chat.primaryDark,
      primarySurface: chat.primarySurface,
      primaryBorder: chat.primaryBorder,
      primaryMuted: chat.primaryMuted,
      divider: chat.divider ?? theme.palette?.divider,
      textPrimary: chat.textPrimary,
      textSecondary: chat.textSecondary,
      textMuted: chat.textMuted,
      primaryContrast: chat.primaryContrast,
    };

    return {
      accent,
      primary: accent.primary,
      primaryDark: accent.primaryDark,
      primarySurface: accent.primarySurface,
      primaryBorder: accent.primaryBorder,
      primaryMuted: accent.primaryMuted,
      radius: theme.customTokens?.radius ?? defaultRadius,
      shadows: theme.customTokens?.shadows ?? defaultShadows,
      spacing: theme.spacing,
      breakpoints: theme.breakpoints,
    };
  }, [theme]);
}
